import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Section, Kicker, Reveal } from "./primitives";

const FAQS = [
  { q: "¿Necesito tener experiencia previa en reactivos o ser químico?", a: "No. El programa aborda el analizador desde la ingeniería: hidráulica, voltajes, tarjetas electrónicas y física óptica. Te enseñaremos los fundamentos que necesitas sin enredos teóricos." },
  { q: "¿Qué pasa si no me puedo conectar a las clases en vivo?", a: "Todas las sesiones quedan grabadas en alta definición y se suben a tu área de alumnos en Hotmart junto con los diagramas descargables. Tienes acceso de por vida y puedes verlas cuantas veces quieras." },
  { q: "¿Qué herramientas necesito para aplicar el método?", a: "No requieres instrumentación costosa. Te mostraremos cómo resolver la gran mayoría de fallas utilizando un multímetro digital básico, herramientas manuales estándar y kits de purga accesibles." },
  { q: "¿Cómo funciona el pago y qué monedas se aceptan?", a: "El cobro se realiza a través de Hotmart. Puedes pagar con tarjeta de crédito, débito, PayPal y métodos locales en efectivo según tu país (como Efecty, OXXO, PSE, etc.). La plataforma convierte automáticamente los $297 USD a tu moneda local." },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <Section id="faq">
      <Reveal>
        <Kicker num="09" label="Preguntas frecuentes" />
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
          Antes de inscribirte
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-10">
          {FAQS.map((f, i) => (
            <div key={f.q} className="border-b border-white/10">
              <button
                data-testid={`faq-item-${i + 1}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 py-6 text-left"
              >
                <span className={`font-display text-base font-semibold transition-colors duration-300 sm:text-lg ${open === i ? "text-cyan-300" : "text-slate-100"}`}>
                  {f.q}
                </span>
                <Plus
                  className={`h-5 w-5 shrink-0 text-cyan-400 transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="max-w-3xl pb-6 text-sm leading-relaxed text-slate-400 sm:text-base">
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </Reveal>
    </Section>
  );
};
